<div class="ig-social-login" role="navigation" aria-label="Account">
  <div *ngIf="mode === 'popup'">
    <ng-content select="[loginBtn]"></ng-content>

    <ig-image *ngIf="profilePicture" [src]="profilePicture" [matMenuTriggerFor]="actionMenu"
              cls="w-10 h-10 rounded-full" alt="profile img" aria-haspopup="menu"
              [attr.aria-expanded]="actionMenu.menuOpen"
              aria-label="Account options" [alt]="'Profile picture of ' + (userName || 'user')"></ig-image>

    <!-- Login Button -->
    <button *ngIf="!profilePicture" 
            (click)="openLoginPopup()"
            class="login-trigger-btn"
            aria-label="Open login options">
      Login
    </button>

    <!-- Login Popup Modal -->
    <div *ngIf="showLoginPopup && !profilePicture" 
         class="login-popup-overlay"
         (click)="closeLoginPopup()"
         role="dialog"
         aria-modal="true"
         aria-labelledby="login-popup-title">
      <div class="login-popup-content" (click)="$event.stopPropagation()">
        <!-- Popup Header -->
        <div class="login-popup-header">
          <h2 id="login-popup-title" class="login-popup-title">Sign in to continue</h2>
          <button (click)="closeLoginPopup()" 
                  class="login-popup-close"
                  aria-label="Close login popup">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>

        <!-- Popup Body -->
        <div class="login-popup-body">
          <div class="modern-login-buttons">
            <div class="login-button-wrapper">
              <ig-google-login
                #google
                class="block w-full"
                *ngIf="!showFallbackGoogleButton">
                <div id="google-signin-btn" class="google-signin-btn"></div>
              </ig-google-login>
              <div
                class="loading-placeholder"
                *ngIf="!showFallbackGoogleButton && !(googleReady$ | async)">
                <ig-spinner></ig-spinner>
              </div>
              <button
                *ngIf="showFallbackGoogleButton"
                type="button"
                class="login-option-btn w-full flex items-center justify-center gap-2 mt-2"
                (click)="onFallbackGoogleLogin()">
                <span class="flex items-center justify-center">
                  <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" class="mr-2">
                    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
                  </svg>
                  <span>Sign in with Google</span>
                </span>
              </button>
            </div>
            <div class="login-button-wrapper">
              <ig-facebook-login #facebook *ngIf="(googleReady$ | async); else facebookLoading" class="block w-full">
              </ig-facebook-login>
              <ng-template #facebookLoading>
                <div class="loading-placeholder">
                  <ig-spinner></ig-spinner>
                </div>
              </ng-template>
            </div>
          </div>

          <div *ngIf="loginError" class="login-error-message">
            {{ loginError }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Horizontal / vertical: mount providers only when logged out (no opacity-only ig-hide duplicates). -->
  <ng-container *ngIf="mode !== 'popup'">
    <img #profileImg *ngIf="profilePicture" [matMenuTriggerFor]="actionMenu" [src]="profilePicture"
         alt="user profile picture" class="w-11 rounded-full cursor-pointer aspect-square" aria-haspopup="menu"
         [attr.aria-expanded]="actionMenu.menuOpen" aria-label="Account options" referrerpolicy="no-referrer">

    <div *ngIf="!profilePicture" [class.flex]="mode==='horizontal'" class="items-center gap-2">
      <ig-google-login #google class="block w-[295px] smallMobile:w-[260px]">
        <div id="google-signin-btn" class="google-signin-btn"></div>
      </ig-google-login>

      <ig-facebook-login #facebook *ngIf="(googleReady$ | async); else loading"
                         class="block mt-3 w-[295px] smallMobile:w-[260px]" [class.!mt-0]="mode==='horizontal'">
      </ig-facebook-login>
    </div>
  </ng-container>

  <ng-template #loading>
    <div class="flex justify-center">
      <ig-spinner></ig-spinner>
    </div>
  </ng-template>

  <mat-menu #actionMenu="matMenu" role="menuitem" aria-label="Sign out">
    <button mat-menu-item (click)="logout()" aria-label="Sign out">Logout</button>
  </mat-menu>

</div>
